import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`reporting-analysis-manager/dashboard?${query}`)
  }
}

export default DashboardService
